<template>
    <component
    v-if="visible" 
    :is="rowFile"
    :form-group-class="[data.width, data.class ? data.class : 'col-md-12']"
    :label="$trans(row.name)"
    v-model="answer" 
    :answers="answers"
    :row="row" />
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        },

        computed: {

            ...mapGetters('form', [
                'isVisible'
            ]),

            visible() {
                return this.isVisible(this.row)
            },

            ...mapState({
                form: state => state.form.form,
                answers: state => state.form.answers
            }),

            data() {
                return this.row.data ? this.row.data : {}
            },

            answer: {
                get() { return _.get(this.answers, this.row.key) },
                set(value) { 
                    this.$store.dispatch('form/setAnswer', {
                        key: this.row.key,
                        value: value
                    }) 
                }
            },

            rowFile() {

                var type = 'Unknown'
                var custom = false

                var rows = require.context('@components/forms/rows', true);

                rows.keys().forEach(file => {

                    file = _.kebabCase(file.replace('.vue', ''))

                    if(file.includes(this.row.type))
                    {
                        type = _.camelCase(this.row.type)
                        type = type[0].toUpperCase() + type.substring(1)
                    }
                })

                // Is there a custom row ?
                if(this.row.type == 'custom')
                {
                    try {
                        var search = this.$options.filters.ucfirst(
                            _.camelCase(this.row.data.custom)
                        )

                        let file = require('@components/forms/rows/'+search);
                        type = search
                    } catch (e) {}
                }
                

                // Is it exists in a custom context ?
                try {
                    let file = require('@components/forms/'+this.form.key+'/rows/'+type);
                    custom = true
                } catch (e) {}


                if(type) {
                    return () => custom 
                    ? import(`@components/forms/${this.form.key}/rows/${type}.vue`)
                    : import(`@components/forms/rows/${type}.vue`);
                }

            }

        },

        methods: {
        }

    }
</script>